(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-v2"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
        document.querySelectorAll(".pim-card-product").forEach((productCard) => {
            const priceElement = productCard.querySelector(
                "span.product-price--displayed.js-product-price"
            );
            const priceContainer = productCard.querySelector(".price-value");
            const dealsCrafterConfigValue = priceElement?.getAttribute(
                "data-deals-crafter-config"
            );

            if (!priceElement || !priceContainer || !dealsCrafterConfigValue) {
                return;
            }

            let dealsCrafterConfig;

            try {
                dealsCrafterConfig = JSON.parse(dealsCrafterConfigValue);
            } catch (error) {
                return;
            }

            const isPreSaleContext =
                global_configs?.isPreSaleEnabled &&
                productCard.getAttribute("data-is-presale-product") === "true";
            const badge = window.getDealsCrafterPromoBadge(
                dealsCrafterConfig,
                {
                    type: isPreSaleContext ? "presale" : "normal",
                    positionClass: "card-product-price-badge-position",
                    badgeClass: "dc-card-product-promo-badge"
                }
            );
            const existingBadge = productCard.querySelector(
                ".dc-card-product-promo-badge"
            );

            if (existingBadge) {
                existingBadge.remove();
            }

            if (badge) {
                productCard.appendChild(badge);
            }
        });

        const dealsCrafterPriceElements = Array.from(
            document.querySelectorAll(
                '.pim-card-product[data-deals-crafter-v2="true"] .js-product-price'
            )
        );
        const previousDealsCrafterFlags = dealsCrafterPriceElements.map(
            (element) => element.getAttribute("data-deals-crafter-product")
        );

        dealsCrafterPriceElements.forEach((element) => {
            element.setAttribute("data-deals-crafter-product", "false");
        });

        try {
            updateCardPrices();
        } finally {
            dealsCrafterPriceElements.forEach((element, index) => {
                const previousFlag = previousDealsCrafterFlags[index];

                if (previousFlag === null) {
                    element.removeAttribute("data-deals-crafter-product");
                } else {
                    element.setAttribute(
                        "data-deals-crafter-product",
                        previousFlag
                    );
                }
            });
        }

        console.log('Loaded card-product.liquid JS');
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
        updateCardPrices();
        console.log('Loaded card-product.liquid JS');
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-scentra"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
        updateCardPrices();
        console.log('Loaded card-product.liquid JS');
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
        addPromoBadgesToMeganav();
    });
  } catch(e) { console.error(e); }
})();

})();
